import { useQuery } from '@tanstack/react-query';

import { useCurrenciesStore } from '@/entities/currency';

import { vabsMyPaymentQuery } from '../api';
import { serializePayment } from '../lib/serialize';

export const usePaymentController = (paymentId?: string) => {
  const currencies = useCurrenciesStore((state) => state.currenciesById);
  const { data, isLoading } = useQuery({
    queryKey: ['payment', paymentId],
    queryFn: () => vabsMyPaymentQuery({ id: paymentId as string }),
    enabled: Boolean(paymentId),
  });

  const paymentNode = data?.nodes?.[0];

  return {
    payment: paymentNode ? serializePayment(paymentNode, currencies) : undefined,
    isLoading,
  };
};
